import CardFeature from '~/components/Molecules/CardFeature/CardFeature.vue'

export default {
  components: {
    hotCarousel: () => import('~/components/Molecules/Carousel/Carousel.vue'),
    hotSolutionsContentBlock: () =>
      import('~/components/Organisms/Solutions/SolutionsContentBlock/SolutionsContentBlock.vue'),
  },

  props: {
    tag: {
      type: String,
    },

    title: {
      type: Object,
    },

    body: {
      type: String,
    },

    contentBlock: {
      type: [Array, Object],
    },

    items: {
      type: Array,
    },

    button: {
      type: Object,
    },

    theme: {
      type: String,
      default: '',
      validator: prop => ['', 'light'].includes(prop),
    },
  },

  data() {
    return {
      cardFeature: CardFeature,
      swiperOptions: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        allowTouchMove: true,
        breakpoints: {
          480: {
            slidesPerView: 1.1,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 32,
          },
          1024: {
            slidesPerView: 2,
            allowTouchMove: false,
            spaceBetween: 32,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    }
  },
}
